var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"text-h4 primary--text"},[_vm._v("Applicant Search")])]),_c('v-col',{attrs:{"cols":"12"}},[_c('ContactPropertySearch')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }